export const stripePeriodLiterals = ['day', 'week', 'month', 'year'] as const;
export type StripePeriodLiteral = (typeof stripePeriodLiterals)[number];

/**
 * Map of possible stripe subscription periods to ISO 8601 duration strings.\
 * Useful for calculating prorated amounts or displaying subscription periods in a standard format.
 *
 * https://docs.stripe.com/api/prices/object?api-version=2025-02-24.acacia#price_object-recurring-interval
 */
export const stripePeriodToISO8601Map: Record<StripePeriodLiteral, string> = {
  day: 'P1D',
  week: 'P1W',
  month: 'P1M',
  year: 'P1Y',
};
